var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.render)?_c('v-btn',{staticClass:"mr-3",attrs:{"icon":"","small":"","color":"black"}},[_c('v-icon',{staticClass:"thick",attrs:{"size":"18"}},[_vm._v(" "+_vm._s(_vm.bellIcon)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }